import { api } from '@rd-web-markets/shared/dist/services/service';

const collaboratingCompaniesService = {
  all: () => api.get('/collaborating_companies'),
  create: (collaborating_company) => api.create('/collaborating_companies', collaborating_company)
}

export default collaboratingCompaniesService;
